import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { AuthService } from '@app/components/login.component/service/auth.service';
import { NTAPMenuService } from '@ntap/common';
import { MenuItem } from 'primeng/api';
import { map, Observable, switchMap } from 'rxjs';

export type MenuModel = MenuItem & {
  badgeClass?: string;
  class?: string;
  items?: Array<MenuModel>;
};

function autoSortSifrarnici(menuitem: any) {
  if (menuitem.name === 'sifrarnici') {
    menuitem.items?.sort((item1: any, item2: any) => {
      const fa = item1.label;
      const fb = item2.label;
      if (!fa || !fb) {
        return 0;
      }
      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
  }
}

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
  public model$: Observable<Array<MenuModel>>;

  constructor(
    private menuService: NTAPMenuService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    const staticModel: Array<MenuModel> = [
      // {
      //     label: 'Dashboards',
      //     icon: 'pi pi-home',
      //     items: [
      //       {
      //         label: 'SaaS Dashboard',
      //         icon: 'pi pi-fw pi-bolt',
      //         routerLink: ['/']
      //       },
      //     ]
      // },
      // {
      //     label: 'Calendar',
      //     icon: 'pi pi-fw pi-calendar',
      //     routerLink: ['/apps/calendar']
      // },
      // {
      //     label: 'Chat',
      //     icon: 'pi pi-fw pi-comments',
      //     routerLink: ['/apps/chat']
      // },
      // {
      //     label: 'Files',
      //     icon: 'pi pi-fw pi-folder',
      //     routerLink: ['/apps/files']
      // },
      // {
      //     label: 'Task List',
      //     icon: 'pi pi-fw pi-check-square',
      //     routerLink: ['/apps/tasklist']
      // }
      //     ]
      // },
      // {
      //     label: 'UI Kit',
      //     icon: 'pi pi-fw pi-star-fill',
      //     items: [
      //         {
      //             label: 'Form Layout',
      //             icon: 'pi pi-fw pi-id-card',
      //             routerLink: ['/uikit/formlayout']
      //         },
      //         {
      //             label: 'Input',
      //             icon: 'pi pi-fw pi-check-square',
      //             routerLink: ['/uikit/input']
      //         },
      //         {
      //             label: 'Float Label',
      //             icon: 'pi pi-fw pi-bookmark',
      //             routerLink: ['/uikit/floatlabel']
      //         },
      //         {
      //             label: 'Invalid State',
      //             icon: 'pi pi-fw pi-exclamation-circle',
      //             routerLink: ['/uikit/invalidstate']
      //         },
      //         {
      //             label: 'Button',
      //             icon: 'pi pi-fw pi-box',
      //             routerLink: ['/uikit/button']
      //         },
      //         {
      //             label: 'Table',
      //             icon: 'pi pi-fw pi-table',
      //             routerLink: ['/uikit/table']
      //         },
      //         {
      //             label: 'List',
      //             icon: 'pi pi-fw pi-list',
      //             routerLink: ['/uikit/list']
      //         },
      //         {
      //             label: 'Tree',
      //             icon: 'pi pi-fw pi-share-alt',
      //             routerLink: ['/uikit/tree']
      //         },
      //         {
      //             label: 'Panel',
      //             icon: 'pi pi-fw pi-tablet',
      //             routerLink: ['/uikit/panel']
      //         },
      //         {
      //             label: 'Overlay',
      //             icon: 'pi pi-fw pi-clone',
      //             routerLink: ['/uikit/overlay']
      //         },
      //         {
      //             label: 'Media',
      //             icon: 'pi pi-fw pi-image',
      //             routerLink: ['/uikit/media']
      //         },
      //         {
      //             label: 'Menu',
      //             icon: 'pi pi-fw pi-bars',
      //             routerLink: ['/uikit/menu'],
      //             routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
      //         },
      //         {
      //             label: 'Message',
      //             icon: 'pi pi-fw pi-comment',
      //             routerLink: ['/uikit/message']
      //         },
      //         {
      //             label: 'File',
      //             icon: 'pi pi-fw pi-file',
      //             routerLink: ['/uikit/file']
      //         },
      //         {
      //             label: 'Chart',
      //             icon: 'pi pi-fw pi-chart-bar',
      //             routerLink: ['/uikit/charts']
      //         },
      //         {
      //             label: 'Misc',
      //             icon: 'pi pi-fw pi-circle-off',
      //             routerLink: ['/uikit/misc']
      //         }
      //     ]
      // }
    ];
    this.model$ = this.authService.user$.pipe(
      switchMap(() => {
        this.menuService.clearMenuItems();
        return this.menuService.getMenuItems().pipe(
          map((data: any) => {
            let menuModel: Array<MenuModel> = [] as Array<MenuModel>;
            if (!!data && data.length > 0) {
              menuModel = [
                ...staticModel,
                ...this.convertToPrimeNgModel(data)
              ] as Array<MenuModel>;
            }
            return menuModel;
          })
        );
      })
    );
  }

  private convertToPrimeNgModel(model: MenuModel[]): MenuModel[] {
    const convertMenuItems = (menuitem: MenuModel) => {
      if (menuitem.icon !== null) {
        menuitem.icon = this.getMaterialIconName(menuitem.icon || '');
      }
      if (
        menuitem.items !== null &&
        menuitem.items?.length !== undefined &&
        menuitem.items?.length > 0
      ) {
        menuitem.items?.map(convertMenuItems);
      } else {
        delete menuitem.items;
      }
      autoSortSifrarnici(menuitem);
    };
    model.map(convertMenuItems);
    return model;
  }

  private getMaterialIconName(iconName: string): string {
    return 'pi pi-' + iconName.replace(/_/g, '-');
  }
}
